import { Application, Bootstrap, useApps } from '@yulintu/freesia-bootstrap';
import './index.less';
import Item from './appItem';
import { URIUtil } from 'freesia-core'
import { App } from 'antd';

export default function AppPortalCard(props) {

    const { message } = App.useApp();

    const { apps, busy } = useApps();

    const toTarget = (url, urlParams, target) => {
        if (url) {
            if (target === '_blank') {
                window.open(URIUtil.appendParams(url, urlParams), '_blank');
            } else {
                window.location.href = URIUtil.appendParams(url, urlParams);
            }
        }
    }

    const itemClick = (c) => {
        if (c.route && c.routePath) {
            toTarget(c.routePath, c.urlParams, c.target);
            return;
        }
        if (c.url) {
            toTarget(c.url, c.urlParams, c.target);
            return;
        }

        message.info(c.message || "暂未开通该功能");
    }

    return <div className='appPortalCardContent wh100'>
        {apps?.filter(c => c.enabled !== false).map((item, index) => {
            return <Item key={index} config={item} onClick={() => {
                itemClick(item)
            }}></Item>
        })}
    </div>
}